<mat-toolbar class="topbar horizontal-topbar">
  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileNav.emit()" *ngIf="!showToggle">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- --------------------------------------------------------------- -->

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->

  <span class="flex-1-auto"></span>

  <div
    class="flex align-items-center justify-content-end gap-1 p-x-24"
    *ngIf="progresso > 0 && progresso < 100"
  >
    <i-tabler name="database-import" class="icon-20 d-flex"></i-tabler>
    <div class="flex flex-col items-end justify-center gap-1">
      <span class="text-sm">{{ progressoTitulo }} ...</span>
      <mat-progress-bar
        class="w-full"
        mode="determinate"
        [value]="progresso"
      ></mat-progress-bar>
    </div>
  </div>

  <div
    *ngIf="showProButtons"
    class="flex items-center justify-start rounded-lg gap-6 bg-[#52223C] px-4 py-3 md:cursor-pointer"
    [routerLink]="['/meu-plano']"
  >
    <mat-icon class="text-yellow-400" fontSet="material-icons-outlined"
      >diamond</mat-icon
    >
    <span class="hidden md:block text-sm text-white pr-2 font-[600]"
      >QUERO SER PRO!</span
    >
  </div>

  <div class="flex flex-col items-end justify-center gap-1 p-x-24">
    <span class="text-sm">{{ nome }}</span
    ><span class="text-xs" *ngIf="perfil === 'Administrador'">{{ perfil }}</span
    ><span class="text-xs" *ngIf="perfil === 'Restaurante'">{{
      nomeFantasia
    }}</span>
  </div>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="notificationMenu"
    aria-label="Notifications"
  >
    <i-tabler
      class="d-flex"
      name="bell"
      [matBadge]="notificacoesNaoLidas > 0 ? notificacoesNaoLidas : null"
      matBadgeColor="primary"
    ></i-tabler>
  </button>

  <mat-menu
    #notificationMenu="matMenu"
    class="topbar-dd cardWithShadow notification-menu"
  >
    <div
      class="notification-header p-x-16 p-y-12 d-flex justify-content-between align-items-center"
      (click)="$event.stopPropagation()"
    >
      <h3 class="m-0">Notificações ({{ notificacoes.length }})</h3>
      <div class="d-flex gap-2">
        <button
          mat-icon-button
          *ngIf="notificacoes.length > 0"
          (click)="marcarTodasComoLidas()"
          matTooltip="Marcar todas como lidas"
        >
          <mat-icon class="icon-18">done_all</mat-icon>
        </button>
        <button
          mat-icon-button
          *ngIf="notificacoes.length > 0"
          (click)="limparTodasNotificacoes()"
          matTooltip="Limpar todas"
        >
          <mat-icon class="icon-18">delete_outline</mat-icon>
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>

    <div class="notification-list" style="max-height: 400px; overflow-y: auto">
      <div
        *ngIf="notificacoes.length === 0"
        class="p-24 text-center text-muted"
      >
        <i-tabler
          name="bell-off"
          class="icon-48 d-flex m-x-auto m-b-8 opacity-50"
        ></i-tabler>
        <p class="m-0">Nenhuma notificação</p>
      </div>

      <div
        *ngFor="let notificacao of notificacoes"
        class="notification-item p-x-16 p-y-12 d-flex gap-3"
        [class.notification-unread]="!notificacao.lida"
        (click)="marcarComoLida(notificacao); $event.stopPropagation()"
        style="cursor: pointer; border-bottom: 1px solid #f0f0f0"
      >
        <div class="notification-icon" style="flex-shrink: 0">
          <mat-icon
            [class.text-success]="notificacao.tipo === 'success'"
            [class.text-danger]="notificacao.tipo === 'error'"
            [class.text-warning]="notificacao.tipo === 'warning'"
            [class.text-info]="notificacao.tipo === 'info'"
          >
            {{
              notificacao.tipo === "success"
                ? "check_circle"
                : notificacao.tipo === "error"
                  ? "error"
                  : notificacao.tipo === "warning"
                    ? "warning"
                    : "info"
            }}
          </mat-icon>
        </div>

        <div class="notification-content flex-1">
          <h4 class="m-0 f-s-14 f-w-600">{{ notificacao.titulo }}</h4>
          <p class="m-0 f-s-13 m-t-4">{{ notificacao.mensagem }}</p>
          <span class="f-s-12 text-muted m-t-4 d-block">
            {{ notificacao.dataHora | date: "dd/MM/yyyy HH:mm" }}
          </span>
        </div>

        <button
          mat-icon-button
          (click)="removerNotificacao(notificacao); $event.stopPropagation()"
          style="flex-shrink: 0"
        >
          <mat-icon class="icon-18">close</mat-icon>
        </button>
      </div>
    </div>
  </mat-menu>

  <button
    mat-icon-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Notifications"
  >
    <mat-icon matPrefix fontSet="material-icons-outlined"> settings </mat-icon>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <!-- <button mat-menu-item>
      <mat-icon class="d-flex align-items-center"
        ><i-tabler name="user" class="icon-18 d-flex"></i-tabler></mat-icon
      >Meu Perfil
    </button>
    <button mat-menu-item>
      <mat-icon class="d-flex align-items-center"
        ><i-tabler name="mail" class="icon-18 d-flex"></i-tabler></mat-icon
      >Minha Conta
    </button> -->

    <button mat-menu-item (click)="alterarSenha()">
      <mat-icon
        class="d-flex align-items-center"
        fontSet="material-icons-outlined"
        >key</mat-icon
      >Alterar senha
    </button>
    <div class="p-x-12 m-t-12">
      <a (click)="logout()" mat-stroked-button color="primary" class="w-100"
        >Sair</a
      >
    </div>
  </mat-menu>
</mat-toolbar>
